import styled from 'styled-components';
export const TimepickerWrapper = styled.div `
    display: flex;
    align-items: center;
    height: 44px;
    padding: 0 10px;
    border: 1px solid ${props => { var _a, _b, _c; return ((_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.input) === null || _b === void 0 ? void 0 : _b.borderColors) === null || _c === void 0 ? void 0 : _c.default) || '#000'; }};
    position: relative;
    &:hover { 
        border: 1px solid ${props => { var _a, _b, _c; return ((_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.input) === null || _b === void 0 ? void 0 : _b.borderColors) === null || _c === void 0 ? void 0 : _c.focus) || '#000'; }};
    }
    ${props => {
    var _a, _b, _c;
    return props.focused && `
        border: 1px solid ${((_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.input) === null || _b === void 0 ? void 0 : _b.borderColors) === null || _c === void 0 ? void 0 : _c.focus) || '#000'}; 
    `;
}}
    ${props => props.disabled && `
        color: ${props.theme.input.borderColors.disabled};
    `}
    ${props => {
    var _a, _b;
    return props.error && `
        border: 1px solid ${((_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.colors) === null || _b === void 0 ? void 0 : _b.error) || '#000'};
    `;
}}
`;
export const TimepickerLabel = styled.div `
    position: absolute;
    top: 0;
    pointer-events: none;
    font-size: 14px; 
    padding: 0 5px 0 5px;
    line-height: 16px;
    font-weight: 600;
    color: #000;
    left: 5px;
    z-index: 2;
    background-color: ${props => props.theme.input.normal.backgroundColor};
    transform: translateY(-50%);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 95%;
    ${props => props.disabled && `
        color: ${props.theme.input.disabled.textColor};
    `}
`;
export const TimeInput = styled.input `
    height: 100%;
    width: 25px;
    background-color: transparent;
    -moz-appearance: textfield;
    -webkit-appearance: textfield;
    -webkit-padding-start: 0px;
    -webkit-padding-end: 0px;
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    &:-moz-ui-invalid {
        box-shadow: none;
        border: none;
        outline: none;
    }
    &[disabled] {
        background: transparent;
        cursor: not-allowed;
    }
`;
export const HoursInput = styled(TimeInput) ``;
export const MinutesInput = styled(TimeInput) `
    text-align: center;
    width: 30px;
`;
export const Separator = styled.span `
    padding: 0 2px;
`;
